import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from '../modal/modal.jsx';
import Box from '../box/box.jsx';
import styles from './back-without-submit.css';

const BackWithoutSubmit = props => {

    const reminderText = '你还没有提交作业，确定离开吗？';
    const leaveBtnText = '离开';
    const submitBtnText = '去提交';

    return (
        <Modal
            className={styles.backWithoutSubmit}
            overlayClassName={styles.backWithoutSubmitOverlay}
            onRequestClose={props.onRequestClose}
        >
            <Box className={styles.testBox}>
                <div>
                    <p>{reminderText}</p>
                    <button
                        className={classnames(styles.leaveBtn, 'btn')}
                        onClick={props.onBack}
                    >{leaveBtnText}</button>
                    <button
                        className={classnames(styles.submitBtn, 'btn')}
                        onClick={props.onRequestClose}
                    >{submitBtnText}</button>
                </div>
            </Box>
        </Modal>
    );
};

BackWithoutSubmit.propTypes = {
    onBack: PropTypes.func,
    onRequestClose: PropTypes.func
};

export default BackWithoutSubmit;
